const gold = {
  100: '#ce983e',
  500: '#996a0a',
  900: '#673f00',
};
export default gold;
